import { createContext } from 'react';
export const ActionIconsContext = createContext(null);
